module.exports = __webpack_public_path__ + "static/store-manager-looking-at-her-tablet-device-mobile.2b48b41e.webp";